<template>
  <div class="digital-navigation" :style="{ width: width + 'px' }">
    <div class="tab" v-if="isShowTab">
      <div @click="changeTab(1)" :class="{ selected: tabIndex === 1 }">页面导览</div>
      <div @click="changeTab(2)" :class="{ selected: tabIndex === 2 }">{{ isPaper ? '文章' : '目录' }}导览</div>
    </div>
    <div class="box box1" :class="{ 'box-tab': isShowTab }" v-if="tabIndex === 1">
      <div class="area" v-if="pages">
        <div class="item" v-for="page in pages" v-bind:key="page.index" :class="{ selected: page.index === pageIndex }" @click="changePage(page, page.index)">
          <div class="image">
            <img v-lazy="page.image" draggable="false" />
          </div>
          <div class="label">第{{ page.index }}页</div>
        </div>
      </div>
    </div>
    <div class="box box2" :class="{ 'box-tab': isShowTab }" v-if="tabIndex === 2">
      <div class="area" v-if="articles">
        <div class="item" v-for="page in articles" v-bind:key="page.page + ':' + page.id" :class="{ selected: page.selected }">
          <div class="title">
            <div class="line"></div>
            <div class="text" :class="{ selected: parseInt(page.page) === pageIndex }" @click="changeArticle(page, page.children ? page.children[0] : null, parseInt(page.page), 1)">
              {{ page.label }}
            </div>
          </div>
          <div class="list">
            <div
              class="text"
              v-for="(article, index) in page.children"
              v-bind:key="index"
              :class="{ selected: parseInt(page.page) === pageIndex && index + 1 === articleIndex }"
              @click="changeArticle(page, article, parseInt(article.page), index + 1)"
            >
              {{ article.label }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'

export default {
  name: 'DigitalNavigation',
  components: {},
  props: {
    width: {
      type: [Number, String],
      default: 300
    },
    pages: {
      type: Array,
      default: () => {
        return []
      }
    },
    articles: {
      type: Array,
      default: () => {
        return []
      }
    },
    isShowTab: {
      type: Boolean,
      default: true
    },
    initTabIndex: {
      type: Number,
      default: 1
    },
    initPageIndex: {
      type: Number,
      default: 1
    },
    initArticleIndex: {
      type: Number,
      default: 1
    }
  },
  computed: {
    ...mapState('book'),
    isPaper() {
      return this.$store.state.book.isPaper
    }
  },
  data() {
    return {
      tabIndex: this.initTabIndex, // TAB页，1：页面导览，2：文章导览
      pageIndex: this.initPageIndex, // 页面当前索引（从1开始）
      articleIndex: this.initArticleIndex // 文章当前索引（从1开始）
    }
  },
  watch: {
    initTabIndex(tabIndex) {
      this.tabIndex = tabIndex
    },
    initPageIndex(pageIndex) {
      this.pageIndex = pageIndex
    },
    initArticleIndex(articleIndex) {
      this.articleIndex = articleIndex
    }
  },
  methods: {
    changeTab(tabIndex) {
      this.tabIndex = parseInt(tabIndex)
      this.$emit('onChangeTab', tabIndex)
    },
    changePage(page, pageIndex) {
      this.pageIndex = parseInt(pageIndex)
      this.articleIndex = 1
      this.$emit('onChangePage', page, parseInt(pageIndex))
    },
    changeArticle(page, article, pageIndex, articleIndex) {
      console.log(page)
      this.pageIndex = parseInt(pageIndex)
      this.articleIndex = parseInt(articleIndex)
      this.$emit('onChangeArticle', page, article, parseInt(pageIndex), parseInt(articleIndex))
    },
    recovery() {
      this.pageIndex = this.initPageIndex
    }
  }
}
</script>
<style lang="scss">
.digital-navigation {
  position: absolute;
  left: 0;
  top: 0;
  width: 300px;
  height: 100%;
  background: #ffffff;
  z-index: 98;
  .tab {
    overflow: hidden;
    div {
      float: left;
      width: 50%;
      text-align: center;
      line-height: 40px;
      font-size: 16px;
      background: #eeeeee;
      cursor: pointer;
    }
    .selected {
      background: #ffffff;
    }
  }
  .box {
    height: 100%;
    overflow: auto;
  }
  .box-tab {
    height: calc(100% - 40px);
  }
  .box1 {
    .area {
      overflow: hidden;
      padding: 20px 10px 10px 10px;
      .item {
        width: 50%;
        padding-top: 10px;
        margin-bottom: 10px;
        float: left;
        text-align: center;
        cursor: pointer;
        &:hover {
          background: #cccccc;
        }
        &:active {
          background: #999999;
        }
        .image {
          margin: auto;
          width: 114px;
          height: 160px;
          font-size: 0;
          line-height: 0;
          background: #e3e3e3;
          overflow: hidden;
          img {
            object-fit: contain;
            width: 100%;
            height: 100%;
          }
        }
        .label {
          line-height: 40px;
          font-size: 14px;
        }
      }
      .selected {
        background: #999999;
      }
    }
  }
  .box2 {
    .area {
      .item {
        font-size: 16px;
        padding-top: 10px;
        border-bottom: 5px solid #e3e3e3;
        &:last-child {
          border-bottom: none;
        }
        .title {
          position: relative;
          .line {
            position: absolute;
            background: red;
            left: 20px;
            top: 14px;
            width: 3px;
            height: 16px;
          }
          .text {
            font-weight: bold;
            line-height: 24px;
            padding: 10px 31px 10px 34px;
            cursor: pointer;
            &:hover {
              background: #f3f3f3;
            }
            &:active {
              background: #e3e3e3;
            }
          }
          .selected {
            background: #e3e3e3;
          }
        }
        .list {
          .text {
            line-height: 24px;
            padding: 10px 31px 10px 34px;
            border-bottom: 1px solid #f3f3f3;
            cursor: pointer;
            &:last-child {
              border-bottom: none;
            }
            &:hover {
              background: #f3f3f3;
            }
            &:active {
              background: #e3e3e3;
            }
          }
          .selected {
            background: #e3e3e3;
          }
        }
      }
    }
  }
}
</style>
